export class ImagenBase64 {
    tipo : number;
    imagen: string;
    formato: string;
    item: number;
    descripcion: string;
}